var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vx-card", { staticClass: "mt-4" }, [
    _vm.loading
      ? _c("div", { staticClass: "text-center py-8" }, [
          _vm._v(_vm._s(_vm.$t("common.loading"))),
        ])
      : !_vm.data.requires_slot_selection
      ? _c("div", { staticClass: "text-muted p-2" }, [
          _vm._v(
            " Este plano não usa horários fixos: o aluno agenda as aulas quando quiser, dentro da cota. "
          ),
        ])
      : _c("div", [
          _c(
            "div",
            { staticClass: "flex flex-wrap items-center justify-between mb-3" },
            [
              _c("div", [
                _c("div", { staticClass: "font-bold" }, [
                  _vm._v("Grade de horários do aluno"),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.quota) +
                      " horário(s) por período · " +
                      _vm._s(_vm.data.seats_ahead) +
                      " aula(s) já reservada(s) à frente "
                  ),
                ]),
              ]),
              !_vm.editing
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "subscriptions.edit",
                          expression: "'subscriptions.edit'",
                        },
                      ],
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.startEdit },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "EditIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Trocar horários"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          !_vm.editing
            ? _c(
                "div",
                { staticClass: "flex flex-wrap gap-2" },
                [
                  _vm._l(_vm.data.current, function (slot) {
                    return _c(
                      "vs-chip",
                      { key: slot.id, attrs: { color: "primary" } },
                      [_vm._v(" " + _vm._s(slot.label) + " ")]
                    )
                  }),
                  !_vm.data.current.length
                    ? _c("span", { staticClass: "text-muted" }, [
                        _vm._v("Sem horários definidos."),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c(
                "div",
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: { show: "", variant: "warning" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-start" },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-1 flex-shrink-0",
                            attrs: { icon: "AlertTriangleIcon" },
                          }),
                          _c("small", [
                            _vm._v(
                              " As aulas já reservadas nos horários antigos serão canceladas e as vagas devolvidas ao clube. Os novos horários passam a valer imediatamente. "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("span", { staticClass: "font-medium" }, [
                      _vm._v(_vm._s(_vm.selected.length)),
                    ]),
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(
                        " de " +
                          _vm._s(_vm.data.quota) +
                          " horário(s) escolhido(s)"
                      ),
                    ]),
                  ]),
                  _vm._l(_vm.data.eligible, function (day) {
                    return _c(
                      "div",
                      { key: day.weekday, staticClass: "mb-2" },
                      [
                        _c("div", { staticClass: "text-muted mb-1" }, [
                          _c("small", { staticClass: "capitalize" }, [
                            _vm._v(_vm._s(day.label)),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex flex-wrap gap-2" },
                          _vm._l(day.slots, function (slot) {
                            return _c(
                              "b-button",
                              {
                                key:
                                  slot.lessonId +
                                  "-" +
                                  slot.availableScheduleId,
                                attrs: {
                                  size: "sm",
                                  variant: _vm.isSelected(slot)
                                    ? "primary"
                                    : "outline-primary",
                                  disabled:
                                    _vm.isFull(slot) && !_vm.isSelected(slot),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggle(slot)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(slot.startTime) +
                                    " · " +
                                    _vm._s(slot.lessonName) +
                                    " "
                                ),
                                _c("span", { staticClass: "ml-50" }, [
                                  _c("small", [
                                    _vm._v(_vm._s(_vm.availabilityLabel(slot))),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "flex justify-end gap-2 mt-3" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-secondary", size: "sm" },
                          on: { click: _vm.cancelEdit },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            size: "sm",
                            disabled: _vm.selected.length !== _vm.data.quota,
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v(" Salvar nova grade ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }